var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MaterialInfoEditDescriptions',{staticClass:"mt-2",attrs:{"data":_vm.materialInfo,"disabled":_vm.disabled},on:{"editMaterial":_vm.editMaterial,"delMaterial":_vm.delMaterial}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }